import { show, hide, registerProject, unregisterProject, activateBasedOnRoute, dispatch } from './UsersnapService';
const UsersnapService = {
  show,
  hide,
  registerProject,
  unregisterProject,
  activateBasedOnRoute,
  dispatch,
};
export default UsersnapService;
